export interface DeviceTelemetryDto {
  deviceFingerprint: string;
  deviceName: string;
  operatingSystem: string;
  browser: string;
  screenResolution: string;
  deviceMemoryGb?: number;
  cpuCores?: number;
  telemetryJson?: string;
}

export const getDeviceTelemetry = (): DeviceTelemetryDto => {
  if (typeof window === 'undefined') {
    return {
      deviceFingerprint: 'SSR',
      deviceName: 'Server',
      operatingSystem: 'Unknown',
      browser: 'Unknown',
      screenResolution: '0x0'
    };
  }

  // Persistent Device Fingerprint
  let fingerprint = localStorage.getItem('mm_device_fingerprint');
  if (!fingerprint) {
    fingerprint = 'dev_' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    localStorage.setItem('mm_device_fingerprint', fingerprint);
  }

  const ua = navigator.userAgent;
  
  // Detect OS
  let os = 'Unknown OS';
  if (ua.indexOf('Win') !== -1) os = 'Windows';
  else if (ua.indexOf('Mac') !== -1) os = 'macOS';
  else if (ua.indexOf('Linux') !== -1) os = 'Linux';
  else if (ua.indexOf('Android') !== -1) os = 'Android';
  else if (ua.indexOf('like Mac') !== -1) os = 'iOS';

  // Detect Browser
  let browser = 'Unknown Browser';
  if (ua.indexOf('Firefox') !== -1) browser = 'Firefox';
  else if (ua.indexOf('SamsungBrowser') !== -1) browser = 'Samsung Internet';
  else if (ua.indexOf('Opera') !== -1 || ua.indexOf('OPR') !== -1) browser = 'Opera';
  else if (ua.indexOf('Trident') !== -1) browser = 'Internet Explorer';
  else if (ua.indexOf('Edge') !== -1 || ua.indexOf('Edg') !== -1) browser = 'Microsoft Edge';
  else if (ua.indexOf('Chrome') !== -1) browser = 'Chrome';
  else if (ua.indexOf('Safari') !== -1) browser = 'Safari';

  const res = `${window.screen.width}x${window.screen.height}`;
  const memory = (navigator as any).deviceMemory || undefined;
  const cores = navigator.hardwareConcurrency || undefined;

  const telemetryObj = {
    devicePixelRatio: window.devicePixelRatio,
    maxTouchPoints: navigator.maxTouchPoints,
    language: navigator.language,
    platform: navigator.platform,
    screenColorDepth: window.screen.colorDepth
  };

  return {
    deviceFingerprint: fingerprint,
    deviceName: `${os} (${browser})`,
    operatingSystem: os,
    browser: browser,
    screenResolution: res,
    deviceMemoryGb: memory,
    cpuCores: cores,
    telemetryJson: JSON.stringify(telemetryObj)
  };
};
